<template>
    <div id="help-container">

        <h2 class="title">{{$t('menu.contact')}}</h2>
        <div class="help-page" v-html="helpPage">
        </div>

    </div>
</template>
<script>
import { RepositoryFactory } from '@/api/RepositoryFactory';

const ConfigurationRepository = RepositoryFactory.get('configuration');
export default {
  name: 'Help',
  data() {
    return {
      helpPages: '',
    };
  },
  mounted() {
    /*    ConfigurationRepository.getConfiguration(this.$store.getters.token).then((response) => {
          this.helpPages = JSON.parse(response.backendConfig.CONTACT_HTML);
        }); */
  },
  computed: {
    helpPage() {
      const lang = this.$i18n.locale;
      const pages = this.$store.getters.htmlContact;
      const filtered = pages.filter(language => language.id === lang);
      if (filtered.length > 0) {
        return filtered[0].value;
      } if (filtered.length === 0) {
        return pages.filter(language => language.id === 'pl').value;
      }
      return 'loading';
    },
  },
};
</script>
<style lang="scss" scoped>
    .help-page {
        text-align: initial !important;
    }
</style>
